import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import StudentForm from './AcademicStatusForm';
import {
  reporteAcademicStatusStudent,
  downloadAcademicStatusStudent,
} from '../../../redux/actions/studentsActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class AcademicStatusContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchCurrentStudent();
  }

  fetchCurrentStudent = () => {
    const { id = '', history } = this.props;
    reporteAcademicStatusStudent(id, {
      onSuccess: (student) => {
        this.setState({ student, loading: false });
      },
      onError: (error) => {
        this.setState({ loading: false });
        if (error && error.status === 404) {
          createErrorMessage('El alumno no existe');
          history.goBack();
        } else {
          createErrorMessage('Error al intentar cargar el estado académico del alumno');
        }
      },
    });
  }

  handleSubmit = (values) => {
    const { id } = values;
    this.setState({ loading: true });
    downloadAcademicStatusStudent(id, {
      onSuccess: () => {
        this.setState({ loading: false });
        createSuccessMessage('Reporte descargado exitosamente');
      },
      onError: (error) => {
        this.setState({ loading: false });
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar descargar el reporte');
        }
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { history } = this.props;
    const {
      student,
      loading,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              Estado acad&eacute;mico alumno
            </h3>
            <h3 className="page-subhead subhead">
              La informaci&oacute;n del alumno de examenes sellados
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {loading
              ? (<LoadingSpinner />)
              : (
                <StudentForm
                  {...student}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={student}
                  history={history}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

AcademicStatusContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default AcademicStatusContainer;
